module.exports = __webpack_public_path__ + "media/assets/images/nosco_io-f39f611270c80a2efe47256a3ae03b26.png";